import { useEffect, useState } from "react";
import { invoiceForm } from "@/utils/objects";
import InvoiceForm from "../forms/InvoiceForm";
import { Inventory } from "@/interface/entityInterface";

const InvoiceCreate = () => {
  const [formProp, setFormProp] = useState(invoiceForm);
  const [selected, setSelected] = useState<Inventory[]>([]);
  useEffect(() => {
    const invoiceItems: any[] = [];
    selected.map((item) =>
      invoiceItems.push({
        title: item.name,
        inventory_id: item.id,
        quantity: item.quantity || 1,
        price: item.price,
        unit: item.unit,
        type: 'product'
      }),
    );

    const total = selected.reduce((acc, item) => acc + (item.price * (item.quantity || 1) || 0), 0);

    setFormProp((prev: any) => {
      return {
        ...prev,
        invoice_items: invoiceItems,
        total
      };
    });

    
  }, [selected]);

  return (
    <InvoiceForm
      formProp={formProp}
      setFormProp={setFormProp}
      otherData={selected}
      setOtherData={setSelected}
    />
  );
};

export default InvoiceCreate;
